<template>
  <div style="padding:10px;overflow:auto;height:80vh">
    <el-form :model="form" label-width="80px">
      <el-form-item label="产品名称">
        <el-input v-model="form.name" style="width:300px;"></el-input>
      </el-form-item>
      <el-form-item label="产品图片">
        <east-img :src="defalutImage" :width="100" :height="100" @read="readImage"></east-img>
      </el-form-item>
      <el-form-item label="目录">
        <el-tree
          :data="form.catalogtree"
          node-key="id"
          default-expand-all
          :expand-on-click-node="false"
          :render-content="renderContent"
          draggable
          :allow-drop="allowDrop"
          :allow-drag="allowDrag"
        ></el-tree>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">立即创建</el-button>
      </el-form-item>
    </el-form>
    <el-dialog
      :title="dialog.title"
      :visible.sync="dialog.show"
      width="30%"
      :before-close="cleardialog"
    >
      <div>
        <el-row>
          <el-col :span="5">目录名:</el-col>
          <el-col :span="19">
            <el-input v-model="dialog.data.label" placeholder="目录名"></el-input>
          </el-col>
        </el-row>
        <el-row style="margin-top:10px">
          <el-col :span="5">内容类型:</el-col>
          <el-col :span="19">
            <el-select v-model="dialog.data.type" placeholder="内容类型">
              <el-option
                v-for="item in datatype"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cleardialog">取 消</el-button>
        <el-button type="primary" @click="dialogsubmit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
let tid = 1;
import config from "../../../api/config";
import EastImg from "../../../components/east-img";
import { addProduct } from "../../../api/gm/api-product";
export default {
  data() {
    return {
      staticURL: config.staticURL, //图片域名
      datatype: [
        { value: 1, name: "无", canadd: true },
        { value: 2, name: "列表", canadd: false },
        { value: 3, name: "单页", canadd: false },
        { value: 4, name: "三维图", canadd: true },
        { value: 5, name: "选项卡", canadd: false }
      ],
      dialog: {
        show: false, //提示框显示隐藏
        data: {
          label: "", //目录名
          type: "" //目录类型
        },
        node: null, //对应树节点
        edit: false, //是否为修改框
        title: "" //弹窗标题
      },
      defalutImage: "/static/icon/add.png",
      imageFile: null,
      form: {
        //表单项
        id: 0,
        name: "",
        image: "",
        catalogtree: [
          {
            id: 0,
            label: "目录",
            type: 0,
            children: []
          }
        ]
      }
    };
  },
  components: {
    "east-img": EastImg
  },
  created() {
    this.form.image = this.defaultImage;
  },
  methods: {
    readImage(f, d) {
      this.imageFile = f;
    },
    //..提交表单
    onSubmit() {
      if (this.form.name.trim() === "") {
        this.$message.error("请输入产品名");
      } else {
        let formData = new FormData();
        Object.keys(this.form).forEach(key => {
          if (key === "image") {
            formData.append(key, this.imageFile);
          } else if (key === "catalogtree") {
            formData.append(key, JSON.stringify(this.form[key]));
          } else if (this.form[key] !== null && this.form[key] !== undefined) {
            formData.append(key, this.form[key]);
          }
        });

        addProduct(formData).then(res => {
          if (res.code === 0) {
            tid = 1;
            this.$confirm("添加成功,是否继续添加?", "提示", {
              confirmButtonText: "添加",
              cancelButtonText: "取消",
              type: "success",
              lockScroll: false
            })
              .then(() => {
                this.$router.go(0);
              })
              .catch(() => {
                this.$router.push({ path: "/gm/product/manage" });
              });
          } else {
            this.$message.error(res.msg);
          }
        });
      }
    },
    //..获取类型对应的中文名
    gettypename(type) {
      var name = "内容类型";
      this.datatype.filter(item => {
        if (item.value == type) {
          name = item.name;
          return;
        }
      });
      return name;
    },
    //..初始化内容
    renderContent(h, { node, data, store }) {
      if (node.id == 1) {
        return (
          <span class="custom-tree-node" width="100%">
            <span>{node.label}</span>
            <span class="mulutype">
              {"[" + this.gettypename(node.data.type) + "]"}
            </span>
            <span style="margin:0 20px;">
              <el-button
                size="mini"
                type="text"
                on-click={() => this.appendtree(data)}
              >
                <i class="el-icon-plus"></i>
              </el-button>
            </span>
          </span>
        );
      } else {
        //编辑,添加,删除
        return (
          <span class="custom-tree-node">
            <span>{node.data.label}</span>
            <span class="mulutype">
              {"[" + this.gettypename(node.data.type) + "]"}
            </span>
            <span style="margin:0 20px;">
              <el-button
                size="mini"
                type="text"
                on-click={() => this.removetree(node, data)}
              >
                <i class="el-icon-minus"></i>
              </el-button>
              <el-button
                size="mini"
                type="text"
                on-click={() => this.edittree(data)}
              >
                <i class="el-icon-edit-outline"></i>
              </el-button>
              <el-button
                size="mini"
                type="text"
                on-click={() => this.appendtree(data)}
              >
                <i class="el-icon-plus"></i>
              </el-button>
            </span>
          </span>
        );
      }
    },
    //..隐藏掉dialog
    cleardialog() {
      this.dialog.show = false; //提示框显示隐藏
      this.dialog.edit = false; //是否为修改框
      this.dialog.data.label = ""; //目录名
      this.dialog.data.type = ""; //目录类型
      this.dialog.node = null; //对应树节点
    },
    //..dialog弹出框确认按钮
    dialogsubmit() {
      this.dialog.edit ? this.editmulu() : this.addmulu();
    },
    //..节点验证
    dialogdatacheck() {
      if (this.dialog.data.label == "") {
        this.$message.error("请填写目录名");
        return false;
      }
      if (this.dialog.data.type == "") {
        this.$message.error("请选择目录内容类型");
        return false;
      }

      return true;
    },
    //..修改树节点触发事件
    edittree(data) {
      this.dialog.edit = true;
      this.dialog.title = "修改目录";
      this.dialog.data.label = data.label;
      this.dialog.data.type = data.type;
      this.dialog.node = data;
      this.dialog.show = true;
    },
    //..将数据修改到树中
    editmulu() {
      if (this.dialogdatacheck()) {
        if (this.dialog.node != null) {
          if (
            this.dialog.data.type != this.dialog.node.type &&
            this.dialog.node.children.length > 0 &&
            !this.canaddChild(this.dialog.data.type)
          ) {
            //类型更换了并且有子栏目
            //新类型不能增加孩子节点
            this.$message.error("所选内容类型不能含有子目录");
          } else {
            this.dialog.node.label = this.dialog.data.label;
            this.dialog.node.type = this.dialog.data.type;
            //清除弹窗
            this.cleardialog();
          }
        }
      }
    },
    //..判断能否添加子栏目
    canaddChild(type) {
      if (type == 0) {
        return true;
      }
      var success = false;
      //获取类型能否添加子栏目
      this.datatype.filter(item => {
        if (item.value == type) {
          success = item.canadd;
          return;
        }
      });
      return success;
    },
    //..添加树节点触发事件
    appendtree(data) {
      if (this.canaddChild(data.type)) {
        this.dialog.edit = false;
        this.dialog.title = "添加目录";
        this.dialog.node = data;
        this.dialog.show = true;
      } else {
        this.$message.error("此内容类型无法添加子栏目");
      }
    },
    //..将数据添加到树中
    addmulu() {
      if (this.dialogdatacheck()) {
        const newChild = {
          id: tid++,
          label: this.dialog.data.label,
          type: this.dialog.data.type,
          children: []
        };

        if (!this.dialog.node.children) {
          this.$set(this.dialog.node, "children", []);
        }
        this.dialog.node.children.push(newChild);
        //清除弹窗
        this.cleardialog();
      }
    },
    //..移除树节点
    removetree(node, data) {
      if (node.id != 1) {
        const parent = node.parent;
        const children = parent.data.children || parent.data;
        const index = children.findIndex(d => d.id === data.id);
        children.splice(index, 1);
      }
    },
    allowDrop(moveNode, inNode, type) {
      if (moveNode.level == inNode.level) {
        // 四种情况
        if (moveNode.nextSibling == undefined) {
          return type == "prev";
        } else if (inNode.nextSibling == undefined) {
          return type == "next";
        } else if (moveNode.nextSibling.id !== inNode.id) {
          return type == "prev";
        } else {
          return type == "next";
        }
      }
    },
    allowDrag(draggingNode) {
      //判断节点能否被拖拽
      return draggingNode.data.id > 0;
    }
  }
};
</script>

<style>
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.mulutype {
  color: #8c939d;
}
</style>


// WEBPACK FOOTER //
// src/pages/gm/product/add.vue